import { useCallback, useState } from 'react';
import { CreateOtherStudyData } from '../types';
import {
  updateOtherStudy as updateOtherStudyRequest,
  deleteOtherStudy as deleteOtherStudyRequest,
  createOtherStudyWithFiles,
} from '../../../api/educationalInformationRequests';

export interface UseActions {
  createOtherStudy: (otherStudy: CreateOtherStudyData) => void;
  updateOtherStudy: (otherStudy: CreateOtherStudyData) => void;
  deleteOtherStudy: (otherStudy: CreateOtherStudyData) => void;
}

type ActionType = 'create' | 'update' | 'delete';

export default function useActions(props: {
  onSuccess: (action: ActionType) => void;
  onError: (action: ActionType, message?: string) => void;
}) {
  const { onSuccess, onError } = props;
  const [loading, setLoading] = useState(false);

  const createOtherStudy = useCallback(
    async (otherStudy: CreateOtherStudyData) => {
      setLoading(true);
      const result = await createOtherStudyWithFiles(otherStudy);
      if (!result.error) {
        return onSuccess('create');
      }
      onError('create', result.error.data.message);
      setLoading(false);
    },
    [onSuccess, onError],
  );

  const updateOtherStudy = useCallback(
    async (id: number, otherStudy: CreateOtherStudyData) => {
      setLoading(true);
      const result = await updateOtherStudyRequest(id, otherStudy);
      if (!result.error) {
        return onSuccess('update');
      }
      onError('update', result.error.data.message);
      setLoading(false);
    },
    [onSuccess, onError],
  );

  const deleteOtherStudy = useCallback(
    async (id: number) => {
      setLoading(true);
      const result = await deleteOtherStudyRequest(id);
      if (!result.error) {
        return onSuccess('delete');
      }
      onError('delete');
      setLoading(false);
    },
    [onSuccess, onError],
  );

  return {
    createOtherStudy,
    updateOtherStudy,
    deleteOtherStudy,
    loading,
  };
}
